import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({
    title: "Pagina non trovata — K Nutrition",
    description: "La pagina che cerchi non esiste. Torna alla home di K Nutrition, Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista a Salerno.",
    path: "/404",
  });
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 pt-24" data-testid="not-found">
      <div className="text-center">
        <p className="font-display italic text-7xl text-taupe mb-6">404</p>
        <h1 className="font-display text-3xl mb-4">Questa pagina non esiste.</h1>
        <p className="text-charcoal/70 mb-8">Forse ci siamo persi noi, ma possiamo rimediare.</p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex rounded-full bg-deeptaupe text-ivory text-sm uppercase tracking-widest2 font-medium px-8 py-4 transition-all duration-300 hover:-translate-y-0.5 hover:bg-charcoal"
        >
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
